import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { ProductAlertButton } from './productAlertButton';

type MainProps = {
  productIds: string[];
  onClearSelection?: () => void;
};

export const ProductsSelectionPanelMain = ({
  productIds,
  onClearSelection,
}: MainProps) => {
  const navigate = useNavigate();

  // Alerts are defined per product, so only enable the action on a single
  // selection. With multiple selections the panel is empty for now.
  const canCreateAlert = productIds.length === 1;
  const productId = productIds[0];

  const handleAlertPress = () => {
    onClearSelection?.();
    navigate(`/products/${productId}/alerts/new`);
  };

  return (
    <View style={styles.container}>
      {canCreateAlert && <ProductAlertButton onPress={handleAlertPress} />}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 12,
  },
});
